import React from "react";
import { Building2, Gem, Home, KeyRound, RefreshCw, Shield, Trees, TrendingUp, Zap } from "lucide-react";
import { loanTypes } from "../mock";

// Named imports only: `import * as` from lucide-react bundles all ~1,600 icons.
export const ICONS = {
  "building-2": Building2,
  gem: Gem,
  home: Home,
  "key-round": KeyRound,
  "refresh-cw": RefreshCw,
  shield: Shield,
  trees: Trees,
  "trending-up": TrendingUp,
  zap: Zap,
};

export default function LoanTypes() {
  return (
    <section className="section-pad relative" style={{ background: "#faf7f2" }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 reveal">
          <div className="max-w-2xl">
            <span className="gold-bar" />
            <div className="text-xs uppercase tracking-[0.28em] font-semibold mt-3" style={{ color: "#6BA82E" }}>Loan Programs</div>
            <h2 className="font-serif text-4xl md:text-5xl font-semibold mt-3 leading-tight" style={{ color: "#070B5F" }}>
              Every loan type. One trusted partner.
            </h2>
          </div>
          <p className="text-slate-600 md:max-w-md">
            From FHA to Jumbo, VA to Commercial and Bridge financing — we place your loan with the
            right investor for the best terms.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {loanTypes.map((lt, i) => {
            const Icon = ICONS[lt.icon] || Home;
            return (
              <div
                key={lt.title}
                className="reveal group relative overflow-hidden rounded-2xl bg-white border border-slate-100 p-6 shadow-3d hover:-translate-y-1.5 hover:shadow-3d-lg transition-all duration-300"
                style={{ transitionDelay: `${(i % 3) * 60}ms` }}
              >
                <div className="absolute -top-8 -right-8 w-28 h-28 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: "radial-gradient(circle, rgba(141,198,63,0.25) 0%, transparent 70%)" }} />
                <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4" style={{ background: "#070B5F" }}>
                  <Icon size={20} style={{ color: "#8DC63F" }} />
                </div>
                <h3 className="font-serif text-xl font-semibold" style={{ color: "#070B5F" }}>{lt.title}</h3>
                <p className="text-sm text-slate-600 mt-2 leading-relaxed">{lt.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
